import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import { number_of_non_deleted_reference_sketches, start_editing_sketches, stop_editing_sketches } from '../../reference_sketches';
import edit_sketches_svg from '../../../assets/img/SVG_icons/Top/four_sketch/edit_sketches.svg';
import { img } from '@phi/components';
import EditSketchesTooltip from './EditSketchesTooltip';

export const EditSketchIcon = edit_sketches_svg;

export default defineComponent({
    props: {
        state: {
            required: true,
            type: Object as PropType<State>,
        },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Edit reference sketches';
        },

        disabled() {
            return !this.state.loaded
                || number_of_non_deleted_reference_sketches() === 0;
        },
    },

    watch: {
        disabled(value: boolean) {
            this.$emit('update:disabled', value);
        },
    },

    emits: {
        'update:disabled': (x: boolean) => true,
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else if (this.state.editing_reference_sketches)
                stop_editing_sketches();
            else
                start_editing_sketches();
        },
    },

    render() {
        return h(BarButton, {
            id: 'edit-sketches-button',
            tippy: 'top',
            active: this.state.editing_reference_sketches,
            disabled: this.disabled,
            selected: this.state.tut_stage === 13,
            onClick: this.onClick,
            help: 'edit_sketches',
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(edit_sketches_svg, this.alt),
            tooltip: EditSketchesTooltip,
        });
    },
});
